import { render, staticRenderFns } from "./CommonTraining.vue?vue&type=template&id=5a074a2d&scoped=true&"
import script from "./CommonTraining.vue?vue&type=script&lang=js&"
export * from "./CommonTraining.vue?vue&type=script&lang=js&"
import style0 from "./CommonTraining.vue?vue&type=style&index=0&id=5a074a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a074a2d",
  null
  
)

export default component.exports